/* styles */
import useStyles from './useStyles'
import { Checkbox } from '@mui/material'
import ModalMenuSuscribersofOrganization from '../../Modals/ModalMenuSuscribersofOrganization'
/* redux */

function TableItem ({ item, id, setLoading }) {
  const classes = useStyles()

  return (
    <>
      <tr className={classes.row}>
        <td className={classes.itemCheck}>
          <Checkbox />
        </td>
        <td className={classes.itemNumber}>{item.subscriber_ref_id}</td>
        <td className={classes.itemName}>{item.subscriber_name}</td>
        <td className={classes.itemCreateUser}>{item.creation_user}</td>
        <td className={classes.itemMaxUsers}>
          {item.subscriber_max_user_count}
        </td>
        <td className={classes.itemKebab}>
          <ModalMenuSuscribersofOrganization
            id={id}
            item={item}
            setLoading={setLoading}
          />
        </td>
      </tr>
    </>
  )
}

export default TableItem
